<template>
  <div class="zj-emergency-onemap-search">
    <div class="zj-emergency-onemap-search-title">
      <span class="zj-emergency-onemap-search-page-title">{{title}}</span>
      <div
        class="zj-emergency-onemap-search-fullscreen-btn select-none"
        v-on:click="fullscreen"
      >{{ isFullScreen? "退出全屏":"全屏"}}</div>
    </div>
    <div class="zj-emergency-onemap-search-box">
      <input
        class="zj-emergency-onemap-search-box-input"
        v-model="searchText"
        type="text"
        placeholder="请输入地图中资源点名称"
      />
      <div class="zj-emergency-onemap-search-box-btn" v-on:click="searchPOI"></div>
    </div>
    <div class="zj-emergency-onemap-search-shrink">
      <div class="shrink-btn select-none" v-on:click="shrink">{{ isShrink? "展开":"收起"}}</div>
    </div>
    <div class="zj-emergency-onemap-search-result">
      <ComponentPoiSearchResult :center="center" :searchText="searchText"></ComponentPoiSearchResult>
    </div>
  </div>
</template>

<script>
import PoiSearchResult from "./PoiSearchResult";

export default {
  name: "ZJEmergencyOneMap-Search",
  componentName: "ZJEmergencyOneMapSearch",
  props: {
    center: {
      type: Object,
      default: function() {
        return [0, 0];
      }
    }
  },
  components: {
    ComponentPoiSearchResult: PoiSearchResult
  },
  data: function() {
    return {
      title: "应急一张图",
      isFullScreen: false,
      isShrink: false,
      searchText: ""
    };
  },
  methods: {
    fullscreen: function() {
      this.isFullScreen = !this.isFullScreen;
      this.theme.header.visiable = !this.isFullScreen;
      this.theme.sidemenu.visiable = !this.isFullScreen;
    },
    shrink: function() {
      this.isShrink = !this.isShrink;

      if (this.isShrink) {
        // eslint-disable-next-line no-undef
        $(".zj-emergency-onemap-search-result").css({ display: "none" });
      } else {
        // eslint-disable-next-line no-undef
        $(".zj-emergency-onemap-search-result").css({ display: "" });
      }
    },
    searchPOI: function() {
      // this.$message({
      //       message: "搜索资源：" + this.searchText,
      //       type: "success"
      // });
      this.$emit("searchPoi", this.searchText);
    }
  },
  watch: {
    searchText: function(val, oldval) {
      if (val != oldval) {
        this.$emit("searchPoi", this.searchText);
      }
    }
  }
};
</script>